const getSelectedCustomMap = ({ selectedCustomMapId, customMaps }) => (
    customMaps.filter(({ publicId }) => publicId === selectedCustomMapId)[0] ?? null
);

export { getSelectedCustomMap };